import Image from "next/image";
import Icon25001 from "@/assets/icon/25001.png";
import Icon25003 from "@/assets/icon/25003.png";
import Icon25005 from "@/assets/icon/25005.png";
import Icon25007 from "@/assets/icon/25007.png";
import Icon25011 from "@/assets/icon/25011.png";
import Icon25013 from "@/assets/icon/25013.png";
import Icon25014 from "@/assets/icon/25014.png";
import Icon25015 from "@/assets/icon/25015.png";
import Icon25016 from "@/assets/icon/25016.png";
import Icon25017 from "@/assets/icon/25017.png";
import Icon25019 from "@/assets/icon/25019.png";
import Icon25022 from "@/assets/icon/25022.png";
import Icon25024 from "@/assets/icon/25024.png";
import Icon25025 from "@/assets/icon/25025.png";
import Icon25030 from "@/assets/icon/25030.png";
import Icon25101 from "@/assets/icon/25101.png";
import Icon25102 from "@/assets/icon/25102.png";
import Icon25103 from "@/assets/icon/25103.png";
import Icon25104 from "@/assets/icon/25104.png";
import Icon25105 from "@/assets/icon/25105.png";
import Icon25106 from "@/assets/icon/25106.png";
import Icon25107 from "@/assets/icon/25107.png";
import Icon25108 from "@/assets/icon/25108.png";
import Icon25109 from "@/assets/icon/25109.png";
import Icon25110 from "@/assets/icon/25110.png";
import Icon25111 from "@/assets/icon/25111.png";
import Icon25201 from "@/assets/icon/25201.png";
import Icon25301 from "@/assets/icon/25301.png";
import Icon25401 from "@/assets/icon/25401.png";
import Icon60101 from "@/assets/icon/60101.png";
import Icon60102 from "@/assets/icon/60102.png";
import Icon60201 from "@/assets/icon/60201.png";
import Icon60301 from "@/assets/icon/60301.png";
import Icon60303 from "@/assets/icon/60303.png";
import Icon60304 from "@/assets/icon/60304.png";
import Icon60305 from "@/assets/icon/60305.png";
import Icon90001 from "@/assets/icon/90001.png";
import Icon90002 from "@/assets/icon/90002.png";
import Icon90003 from "@/assets/icon/90003.png";
import Icon90101 from "@/assets/icon/90101.png";
import Icon90201 from "@/assets/icon/90201.png";
import Icon90202 from "@/assets/icon/90202.png";
import Icon90301 from "@/assets/icon/90301.png";
import Icon91001 from "@/assets/icon/91001.png";
import Icon100002 from "@/assets/icon/100002.png";
import Icon100005 from "@/assets/icon/100005.png";
import Icon123458 from "@/assets/icon/123458.png";
import Icon123460 from "@/assets/icon/123460.png";
import Icon123461 from "@/assets/icon/123461.png";
import Icon123463 from "@/assets/icon/123463.png";
import Icon123473 from "@/assets/icon/123473.png";
import Icon123474 from "@/assets/icon/123474.png";
import Icon123475 from "@/assets/icon/123475.png";

export function GameIcon({
  roomId,
  width,
  height,
}: {
  roomId: string;
  width: number;
  height: number;
}) {
  const icon = {
    "100002": Icon100002,
    "100005": Icon100005,
    "123458": Icon123458,
    "123460": Icon123460,
    "123461": Icon123461,
    "123463": Icon123463,
    "123473": Icon123473,
    "123474": Icon123474,
    "123475": Icon123475,
    "25001": Icon25001,
    "25003": Icon25003,
    "25005": Icon25005,
    "25007": Icon25007,
    "25011": Icon25011,
    "25013": Icon25013,
    "25014": Icon25014,
    "25015": Icon25015,
    "25016": Icon25016,
    "25017": Icon25017,
    "25019": Icon25019,
    "25022": Icon25022,
    "25024": Icon25024,
    "25025": Icon25025,
    "25030": Icon25030,
    "25101": Icon25101,
    "25102": Icon25102,
    "25103": Icon25103,
    "25104": Icon25104,
    "25105": Icon25105,
    "25106": Icon25106,
    "25107": Icon25107,
    "25108": Icon25108,
    "25109": Icon25109,
    "25110": Icon25110,
    "25111": Icon25111,
    "25201": Icon25201,
    "25301": Icon25301,
    "25401": Icon25401,
    "60101": Icon60101,
    "60102": Icon60102,
    "60201": Icon60201,
    "60301": Icon60301,
    "60303": Icon60303,
    "60304": Icon60304,
    "60305": Icon60305,
    "90001": Icon90001,
    "90002": Icon90002,
    "90003": Icon90003,
    "90101": Icon90101,
    "90201": Icon90201,
    "90202": Icon90202,
    "90301": Icon90301,
    "91001": Icon91001,
  }[roomId];

  return <Image src={icon} alt={roomId} width={width} height={height} />;
}
